import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const Audio = ({ className, ...props }) => (
  <audio {...props} className={classNames(className, styles['a-audio'])} />
)

export default Audio
